module.exports = require("core-js-pure/stable/instance/bind");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/bind.js
// module id = 588
// module chunks = 0